import { Controller } from '@hotwired/stimulus';

export default class GoalPerformanceController extends Controller {
  static targets = ['goalPerformanceDatePicker'];

  declare goalPerformanceDatePickerTarget: HTMLElement;

  toggleDatePicker(event: Event) {
    if ((event.target as HTMLInputElement).value === 'custom') {
      event.stopPropagation();
      this.goalPerformanceDatePickerTarget.classList.remove('u-displayNone');
    } else {
      this.goalPerformanceDatePickerTarget.classList.add('u-displayNone');
    }
  }
}
